import React from 'react';
import {observer} from 'mobx-react';
import {Button} from 'shared/components/buttons';
import {FormattedMessage} from 'react-intl';
import {auth} from 'main/tools';

const PerformanceReviewTask = observer(({uiState}) => {
  const {task} = uiState;

  return (
    <div>
      <div className='mb3 jumbo'>
        <FormattedMessage id={`inbox.reviewee_explanation.${task.relatedAttributes.reviewType}`} values={{name: task.subjectEmployee.name}}/>
      </div>
      {(task.assignedToCurrentUser || auth.hasAccess('::MANAGE_PERFORMANCE_MANAGEMENT')) && <Button onClick={() => window.location.href = `/reviews/reviews/${task.relatedAttributes.cycleId}/reviewee/${task.relatedAttributes.revieweeId}/employee/${task.subjectEmployee.id}`}>
        <FormattedMessage id='inbox.Write Review'/>
      </Button>}
    </div>
  );
});

export default PerformanceReviewTask;
